<template>
  <div class="bg-black">
    <div class="container">
      <div class="row d-flex justify-content-center align-items-center login-container">
        <div class="col-11 col-sm-6">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title text-center">Login</h4>
              <form class="form-signin" v-on:submit.prevent="login">
                <div class="form-label-group mb-3">
                  <input
                    v-model="username"
                    type="email"
                    id="usuario"
                    class="form-control"
                    placeholder="Email"
                    required
                    autofocus
                  />
                </div>

                <div class="form-label-group mb-3">
                  <input
                    v-model="password"
                    type="password"
                    id="password"
                    class="form-control"
                    placeholder="Password"
                    required
                  />
                </div>

                <div class="d-flex justify-content-center">
                  <button
                    class="primary-btn"
                    type="submit"
                  >
                    Entrar
                  </button>
                </div>
                <p v-if="error" class="text-danger text-center mt-3">
                  usuario incorrecto
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fire from "./../fire";
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      logged: false,
      error: false,
      uid: null
    };
  },
  methods: {
    login() {
      this.error = false;
      fire
        .auth()
        .signInWithEmailAndPassword(this.username, this.password)
        .then(data => {
          this.logged = true;
          this.uid = data.user.uid;
          sessionStorage.setItem("uid", data.user.uid);
          console.log(data);
          this.$router.push("admin");
        })
        .catch(err => {
          this.error = true;
          console.log(err);
        });
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
.bg-black {
  background-color: #141414!important;
}
.opacity {
  opacity: 0.7;
}
img {
  &.imagen {
    width: 30px;
    height: auto;
  }
}
table td{
  vertical-align: middle;
}
.titulo{
  font-size: 1.1em;
}
</style>
